document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.full-card-link[data-url]').forEach(card => {
		card.addEventListener('click', (e) => {
			const $this = $(e.currentTarget);
			const dataUrl = $this.data('url');

			if (dataUrl === '#popupForm') {
				$.fancybox({
					src: dataUrl,
					type: 'inline',
				});
			} else {
				if (!e.target.closest('a, button')) {
					window.location.href = card.getAttribute('data-url');
				}
			}
		});
	});
});
